var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-log-records__record",class:`is-${_vm.level}`},[_c('div',{staticClass:"task-log-records__time"},[_vm._v(" "+_vm._s(_vm._f("formatTime")(_vm.source.time))+" ")]),_c('div',{staticClass:"task-log-records__output",domProps:{"innerHTML":_vm._s(_vm.$options.filters.formatLog(_vm.source.output))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }